import AlarmsManager from './container'

export default AlarmsManager
